import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { authAPI } from '../services/api';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setError('');
    setLoading(true);
    try {
      await authAPI.completeReset(token, password);
      setDone(true);
      // Sign in fresh rather than guessing at a session from a reset link.
      setTimeout(() => navigate('/login', { replace: true }), 1800);
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'Could not reset the password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ maxWidth: 420, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ mb: 1 }}>Set a new password</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Choose a password of at least 8 characters.
          </Typography>

          {done ? (
            <Alert severity="success">
              Password updated. Taking you to the sign-in page&hellip;
            </Alert>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField fullWidth type="password" label="New password" value={password}
                onChange={(e) => setPassword(e.target.value)} sx={{ mb: 2 }} autoFocus />
              <TextField fullWidth type="password" label="Confirm new password" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} sx={{ mb: 3 }} />
              <Button fullWidth type="submit" variant="contained" disabled={loading}>
                {loading ? 'Saving\u2026' : 'Save password'}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
